import { Box, Card, CardActionArea, Typography } from "@mui/material";
import { type ElementType } from "react";

export interface ActivityCardProps {
  title: string;
  count: number | string;
  icon: React.ReactNode;
  color: "primary" | "secondary" | "success" | "info" | "warning" | "error";
  subtitle?: string;
  onClick?: () => void;
  "data-testid"?: string;
}

export const ActivityCard = ({
  title,
  count,
  icon,
  color,
  subtitle,
  onClick,
  "data-testid": testId,
}: ActivityCardProps) => {
  const CardComponent = (onClick ? CardActionArea : Box) as ElementType;

  return (
    <Card
      sx={{
        backgroundColor: `${color}.lighter`,
        borderRadius: 2,
        color: `${color}.main`,
        height: "100%",
        minHeight: 120,
        overflow: "visible",
      }}
    >
      <CardComponent
        onClick={onClick}
        aria-label={`${title}: ${count}`}
        data-testid={testId}
        sx={{
          alignItems: "center",
          display: "flex",
          height: "100%",
          justifyContent: "space-between",
          p: 3,
          position: "relative",
          width: "100%",
        }}
      >
        <Box>
          <Typography variant="h5" sx={{ color: `${color}.main`, mb: 1 }}>
            {count}
          </Typography>
          <Typography variant="subtitle2" sx={{ color: `${color}.main`, opacity: 0.72 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="caption" sx={{ color: `${color}.main`, display: "block", opacity: 0.64 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            "& > *": {
              height: 32,
              width: 32,
            },
            alignItems: "center",
            backgroundColor: "white",
            borderRadius: "50%",
            color: `${color}.main`,
            display: "flex",
            height: 48,
            justifyContent: "center",
            width: 48,
          }}
        >
          {icon}
        </Box>
      </CardComponent>
    </Card>
  );
};
